import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SettlementComponent } from '../settlement/settlement.component';
import { CalenderTranslationService } from 'src/app/services/calendar-translation/calendar-translation.service';

@Component({
  selector: 'app-selectdate',
  templateUrl: './selectdate.component.html',
  styleUrls: ['./selectdate.component.scss']
})
export class SelectdateComponent implements OnInit {
  @Input() selectedAction: any;
  start_date;
  end_date;
  load = false;
  from_opened: boolean= false;
  to_start: boolean = false;
  submittriggered = false;
  constructor(
    public dialogRef: MatDialogRef<SettlementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private calendarI18nService: CalenderTranslationService
    ) { }

  ngOnInit() {
    this.router.events.subscribe(val => {
      this.onNoClick();
    });

    if(this.data.selectedAction){
      this.selectedAction = this.data.selectedAction;
      // console.log('partners',this.partner )
    }
  }

  get calendarLocale(){
    return this.calendarI18nService.locale;
  }

setVariables(data?){
  this.submittriggered
  if(!this.start_date || !this.end_date ){
    return
  }
  const params = {start_date:this.start_date, end_date:this.end_date, from_opened:this.from_opened, to_start: this.to_start, load:this.load}
  this.dialogRef.close(params);


}
onNoClick(): void {
  this.dialogRef.close(this.load);
}
}
